@if (fixture && selectedMarketTitle) {
    <div class="horses-race-container">
        @if (vm.timeformTipRunner || vm.selectedMarketView === marketViews.Forecast || vm.selectedMarketView === marketViews.Tricast) {
            <section class="horses-race-section">
                @if (vm.timeformTipRunner) {
                    @let participantOption = vm.prices[vm.timeformTipRunner.id];
                    <div class="timeform-tip-container">
                        <ms-timeform-tip [participantOption]="participantOption" [fixture]="fixture" [participant]="vm.timeformTipRunner" />
                    </div>
                }
                @if (vm.selectedMarketView === marketViews.Forecast || vm.selectedMarketView === marketViews.Tricast) {
                    <div>
                        <ms-race-timeform-spotlight [fixture]="fixture" />
                        @if (vm.selectedMarketView === marketViews.Forecast && vm.canSelectTopForecast) {
                            <div class="align-spotlight-button">
                                <button class="ms-button spotlight-button" (click)="onSelectTopTwo()">
                                    {{ sitecore.horseRacing.raceDetails.SelectTopTwo }}
                                </button>
                            </div>
                        }
                        @if (vm.selectedMarketView === marketViews.Tricast && vm.canSelectTopTricast) {
                            <div class="align-spotlight-button">
                                <button class="ms-button spotlight-button" (click)="onSelectTopThree()">
                                    {{ sitecore.horseRacing.raceDetails.SelectTopThree }}
                                </button>
                            </div>
                        }
                    </div>
                }
            </section>
        }
        <section class="horses-race-participants">
            <section class="market-tab-bar-section">
                @if (marketTabs) {
                    <ds-tabs-group
                        class="derived-race-tabs"
                        fullWidthTabs="false"
                        size="small"
                        variant="horizontal"
                        scrollable="true"
                        showBorderBottom="true"
                        scrollSpeed="slow"
                        [scrollDistance]="200"
                        (activeTabChange)="setSelectedMarket($event)">
                        @for (tab of marketTabs; track tab.id) {
                            <ds-tab [name]="tab.id.toString()">
                                <ng-container *dsTabHeader>
                                    <span [class.selected]="tab.active">
                                        {{ tab.title }}
                                    </span>
                                </ng-container>
                            </ds-tab>
                        }
                        <ds-divider />
                    </ds-tabs-group>
                }

                @if (showMarketHelp && optionGroup) {
                    <ms-market-help [optionGroup]="optionGroup" />
                }
                @if (isOptionBet && subMarkets.length && displayType === groupTypes.Regular) {
                    <section class="market-picker">
                        <ms-scroll-adapter [msScrollSelectedInView]="subSelectedMarketId?.toString()">
                            <ul class="racing-toggle">
                                @for (marketTitle of subMarkets; track marketTitle) {
                                    <li
                                        class="racing-toggle-item"
                                        [class.selected]="marketTitle.id === subSelectedMarketId"
                                        [attr.data-menu-item-id]="marketTitle.id">
                                        <button class="market-btn" [innerText]="marketTitle.title" (click)="setSelectSubMarket(marketTitle)"></button>
                                    </li>
                                }
                            </ul>
                        </ms-scroll-adapter>
                    </section>
                }
            </section>
            <div (swipeleft)="onSwipe('left')" (swiperight)="onSwipe('right')">
                @if (!isOptionBet && isWinMarketSelected(selectedMarketTitle, marketViews.Win)) {
                    <ms-horses-race-win-market [fixture]="fixture" />
                }
                @if (isOptionBet && optionGroup && (displayType === groupTypes.Wincast || displayType === groupTypes.Regular)) {
                    <ms-horses-derived-race-win-market
                        [optionGroup]="optionGroup"
                        [displayType]="displayType"
                        [participantOptionGroups]="participantOptionGroups"
                        [fixture]="fixture"
                        [selectedMarketTitle]="selectedMarketTitle"
                        [optionPickTrackingsource]="getPickTrackingSource(sportTracking)"
                        [trackingOptions]="getPickTrackingOptions()" />
                }
                @if (isWinMarketSelected(selectedMarketTitle, marketViews.Forecast) || marketType === 'Forecast') {
                    <ms-horses-forecast
                        [mode]="ForecastComponentMode.Forecast"
                        [fixture]="fixture"
                        [selectTopTwo]="selectTopTwo"
                        [selectTopThree]="selectTopThree"
                        [optionGroup]="optionGroup"
                        [participantOptionGroups]="participantOptionGroups"
                        [msAutomation]="{ mode: 'forecast' }" />
                }
                @if (isWinMarketSelected(selectedMarketTitle, marketViews.Tricast) || marketType === 'Tricast') {
                    <ms-horses-forecast
                        [mode]="ForecastComponentMode.Tricast"
                        [fixture]="fixture"
                        [selectTopTwo]="selectTopTwo"
                        [selectTopThree]="selectTopThree"
                        [optionGroup]="optionGroup"
                        [participantOptionGroups]="participantOptionGroups"
                        [msAutomation]="{ mode: 'tricast' }" />
                }
                @if (isOptionBet && displayType === groupTypes.Outrights) {
                    <ms-horses-specials
                        [optionGroups]="optionGroups"
                        [event]="fixture"
                        [trackingSource]="getPickTrackingSource(sportTracking)"
                        [trackingOptions]="getPickTrackingOptions()" />
                }
            </div>
        </section>
    </div>
}
